var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ListingTableFilter",
    {
      attrs: {
        filter: _vm.filter,
        valuesHumanized: _vm.appliedFilterLabels,
        filterConfig: _vm.filterConfig
      },
      on: {
        updateFilter: _vm.updateFilter,
        updateVisibility: _vm.updateVisibility,
        removeFilter: _vm.removeFilter
      }
    },
    [
      _c(
        "template",
        { slot: "filterDropdownContent" },
        _vm._l(_vm.filter.options, function(option) {
          return _c(
            "CompassDropdownOption",
            _vm._b(
              { key: option.id, attrs: { value: option.id } },
              "CompassDropdownOption",
              option,
              false
            )
          )
        }),
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }